import classNames from "classnames";
import React, { SetStateAction, useEffect, useState } from "react";
import { HiOutlineViewList, HiViewGrid } from "react-icons/hi";

type ListTypesProps = {
	setLayout:React.Dispatch<SetStateAction<string>>
}

export default function ListTypes({setLayout}:ListTypesProps) {
	const [layoutType, setLayoutType] = useState("LISTING");
	const style = "border-solid border-2 border-primary-50 rounded-md p-2 hover:cursor-pointer";

	useEffect(()=>{
		setLayout(layoutType);
		console.log(layoutType)
	}
	,[layoutType])
	
	return (
		<div className="flex flex-row gap-1 w-full">
			<div
				className={classNames(
					layoutType === "LISTING" ? "bg-primary-50" : null,
					style,
				)}
			>
				<HiOutlineViewList size={24} onClick={()=>{setLayoutType("LISTING")}}/>
			</div>
			<div
				className={classNames(
					layoutType === "CARD" ? "bg-primary-50" : null,
					style,
				)}
			>
				<HiViewGrid size={24} onClick={()=>{setLayoutType("CARD")}}/>
			</div>
		</div>
	);
}
